import BlueCargoLogo from 'components/BlueCargoLogo';
import * as React from 'react';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';
import fonts from '../../styles/typography.module.css';

interface MaintenanceFlag {
  message?: string;
}

export const Maintenance: React.FC = () => {
  const maintenance = useFeatureFlag<MaintenanceFlag>(FeatureFlag.Maintenance);

  return (
    <div
      className={`w-screen h-screen ${fonts.font} bg-white flex flex-col items-center justify-center`}
    >
      <h4 className="uppercase text-blue-900 font-medium pt-16">
        BlueCargo is down for scheduled maintenance.
      </h4>
      <div className="flex-grow flex items-center">
        <div className="text-center space-y-4 text-gray-600">
          <BlueCargoLogo variant="larger-blue" />
          <h1 className="font-semibold">We are making BlueCargo better and faster!</h1>
          <div className="font-medium">
            <h3>And we can&apos;t wait for you to see it.</h3>
            <h3>{maintenance?.message ? maintenance.message : 'Please check back soon.'}</h3>
          </div>
        </div>
      </div>
      <div className="pb-32">
        Any questions?{' '}
        <a href="mailto:contact@bluecargo.io" className="underline">
          Contact us
        </a>
      </div>
    </div>
  );
};
